var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoadingArticle || !_vm.compiledHtml)?_c('skeleton',{attrs:{"id":"news-article"}}):(!!_vm.compiledHtml)?_c(_vm.compiledHtml,{tag:"component"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }